import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "h-[184px] bg-secondary border-t border-ternary flex divide-x py-[10px] md:px-2 xl:px-[10px] mb-16 xl:mb-0"
}
const _hoisted_2 = { class: "bg-ternary w-10 h-full rounded hidden md:flex items-center justify-center hover:cursor-pointer" }
const _hoisted_3 = { class: "px-2 md:pr-6 xl:pr-8 flex flex-col text-left" }
const _hoisted_4 = { class: "text-muted sf-pro font-semibold text-base leading-[21px] xl:text-xl xl:leading-[28px] mb-5" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "md:ml-4" }
const _hoisted_7 = { class: "text-muted sf-pro-xs mb-2" }
const _hoisted_8 = { class: "text-brown sf-pro font-semibold text-base leading-[21px] xl:leading-[24px]" }
const _hoisted_9 = {
  key: 1,
  class: "flex-1 flex items-center justify-between"
}
const _hoisted_10 = { class: "px-2 md:pl-6 xl:pl-8 flex flex-col text-left" }
const _hoisted_11 = { class: "text-muted sf-pro font-semibold text-base leading-[21px] xl:text-xl xl:leading-[28px] mb-5" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "md:ml-4" }
const _hoisted_14 = { class: "text-muted sf-pro-xs mb-2" }
const _hoisted_15 = { class: "text-brown sf-pro font-semibold text-base leading-[21px] xl:leading-[24px]" }
const _hoisted_16 = { class: "bg-ternary w-10 h-full rounded hidden md:flex items-center justify-center hover:cursor-pointer" }

import { computed } from "vue";
import { RelatedBlog } from "@/types/blogs";
import { ROUTE_NAMES } from "@/constants/routeNames";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { useLangStore } from "@/stores/langStore";

const isHidedButtons = true;


export default /*@__PURE__*/_defineComponent({
  __name: 'BlogFooter',
  props: {
    relatedBlogs: {}
  },
  setup(__props: any) {

const props = __props;

const prevBlog = computed(() => props.relatedBlogs?.[1] ?? null);
const nextBlog = computed(() => props.relatedBlogs?.[0] ?? null);

const langStore = useLangStore();
const { t } = useI18n();
const router = useRouter();

function openRelatedBlog(relatedBlog: RelatedBlog) {
  router.push({
    name: ROUTE_NAMES.BLOG_DETAIL,
    params: { id: relatedBlog.id },
  });
}

return (_ctx: any,_cache: any) => {
  return (prevBlog.value || nextBlog.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (prevBlog.value !== null)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["flex-1 flex items-center", isHidedButtons ? 'justify-end' : 'justify-between'])
            }, [
              _withDirectives(_createElementVNode("div", _hoisted_2, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("svg", {
                  width: "11",
                  height: "22",
                  viewBox: "0 0 11 22",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M10 1L1 11L10 21",
                    stroke: "#29160E",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1)
              ]))], 512), [
                [_vShow, !isHidedButtons]
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("blog_detail.prev_article")), 1),
                _createElementVNode("div", {
                  class: "flex cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (openRelatedBlog(prevBlog.value)))
                }, [
                  _createElementVNode("img", {
                    src: prevBlog.value.image_url,
                    alt: "Prev bolg image",
                    class: "h-20 w-[110px] rounded-[10px] hidden md:block object-cover"
                  }, null, 8, _hoisted_5),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(prevBlog.value.created_at), 1),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(prevBlog.value.titles[_unref(langStore).current] ||
                prevBlog.value.titles[_unref(langStore).fallbackLang]), 1)
                  ])
                ])
              ])
            ], 2))
          : _createCommentVNode("", true),
        (nextBlog.value !== null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(t)("blog_detail.next_article")), 1),
                _createElementVNode("div", {
                  class: "flex cursor-pointer",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (openRelatedBlog(nextBlog.value)))
                }, [
                  _createElementVNode("img", {
                    src: nextBlog.value.image_url,
                    alt: "Prev bolg image",
                    class: "h-20 w-[110px] rounded-[10px] hidden md:block object-cover"
                  }, null, 8, _hoisted_12),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, _toDisplayString(nextBlog.value.created_at), 1),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(nextBlog.value.titles[_unref(langStore).current] ||
                nextBlog.value.titles[_unref(langStore).fallbackLang]), 1)
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_16, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("svg", {
                  width: "11",
                  height: "22",
                  viewBox: "0 0 11 22",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M1 1L10 11L1 21",
                    stroke: "#29160E",
                    "stroke-width": "2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  })
                ], -1)
              ]))], 512), [
                [_vShow, !isHidedButtons]
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})